import React from 'react';
import {IndexRoute, Route} from 'react-router';
import {
    App,
    Home,
    About,
    HowItWorks,
    Legal,
    Toolkit,
    FAQ,
    Media,
    FundTobaccoInvestments,
    List,
    Compare,
    Family,
    NotFound,
    IndexFunds,
    TargetDateSeries,
    FundRedirect,
  } from 'containers'

export default (store) => {
  const routeChangeFocusHandler = (p, n) => { 
    // document.getElementById('app-container').focus() 
  }

  return (
    <Route path="/" onChange={routeChangeFocusHandler} component={App}>
      { /* Home (main) route */ }
      <IndexRoute component={Home}/>

      { /* Routes */ }
      <Route path="/funds/:fundId/:investmentVehicleId/:ticker" component={FundRedirect}/>
      <Route path="/funds/:fundId/:investmentVehicleId" component={FundRedirect}/>
      <Route path="/fund/:name/:ticker/tobacco-profile/:fundId/:investmentVehicleId" component={FundTobaccoInvestments}/>
      <Route path="/funds" component={List}/>
      <Route path="/compare" component={Compare}/>
      <Route path="/families" component={Family}/>
      <Route path="/about" component={About}/>
      <Route path="/how-it-works" component={HowItWorks}/>
      <Route path="/legal" component={Legal}/>
      <Route path="/toolkit" component={Toolkit}/>
      <Route path="/faq" component={FAQ}/>
      <Route path="/media" component={Media}/>
      <Route path="/index-funds" component={List}/>
      <Route path="/target-date-funds" component={List}/>
      <Route path="/target-date-funds/:strategyName" component={List}/>

      { /* Catch all route */ }
      <Route path="*" component={NotFound} status={404} />
    </Route>
  );
};
